import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { TaskAPI, Task } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { updateDocTask } from 'data/documents';
import { UpdateTaskPayloadOptions } from 'data/documents/actions';
import { saveTasks } from 'data/tasks/slice';

function* updateDocTaskManager(
  action: PayloadAction<{
    projectId: number;
    taskId: number;
    partialTask: Partial<Task>;
    options: UpdateTaskPayloadOptions;
  }>,
) {
  const { payload } = action;
  const { projectId, taskId, partialTask, options } = payload;

  try {
    const response = yield TaskAPI.updateTask(projectId, taskId, partialTask);

    if (options?.resolveCallback) {
      options.resolveCallback(response);
    }

    yield put(saveTasks({ data: [response], fetchStatus: FetchStatus.Loaded }));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // TODO: handle error
  }
}
export const watchUpdateDocTasks = function* () {
  yield takeLatest(updateDocTask.type, updateDocTaskManager);
};
